const deviceList = () => import('@/pages/device/list/index.vue');
const deviceDetail = () => import('@/pages/device/list/detail.vue');

export default [{
    path: '/device/list',
    component: deviceList,
    meta: [{
        name: '设备管理'
    },
    {
        name: '设备列表',
        activeRoute: '/device/list'
    }]
}, {
    path: '/device/detail',
    component: deviceDetail,
    meta: [{
        name: '设备管理'
    }, {
        name: '设备列表',
        url: '/device/list'
    }, {
        name: '设备详情',
        activeRoute: '/device/list'
    }]
}];